/* eslint-disable camelcase */
import 'isomorphic-fetch';
import ApiClickoutError from './ApiClickoutError';
import reportErrorToSentry from '~/utils/reportErrorToSentry';

const END_POINTS = {
  CLICKOUT_CLICK: '/clickout/clicks',
};

const FETCH_OPTIONS = {
  method: 'POST',
  mode: 'cors',
  headers: {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  },
};

class Api {
  static post(url, body) {
    let response = null;
    return fetch(url, { body, ...FETCH_OPTIONS })
      .then(res => {
        response = res;
        return response.json();
      })
      .then(json => {
        if (json.errors) {
          const error = Array.isArray(json.errors) ? json.errors[0] : json.errors;
          const errorMessage = error.detail;
          throw new ApiClickoutError(error.status, errorMessage, response.status);
        }

        return json;
      })
      .catch(error => {
        reportErrorToSentry(error);
        throw error;
      });
  }

  constructor(urlBase) {
    this.urlBase = urlBase;
  }

  /**
   * Request clickout to know the Ad's target
   * @param {Object} data
   * @returns {Object}
   *
   * @throws {ApiClickoutError}
   * @memberof Api
   */
  send(data) {
    const url = `${this.urlBase}${END_POINTS.CLICKOUT_CLICK}`;
    const { ab_test } = data;

    const body = JSON.stringify({
      data: {
        type: 'clicks',
        attributes: {
          ad: {
            id: data.ad_id,
            position: data.position || 0,
          },
          site: {
            country_code: data.country_code,
            vertical_name: data.vertical_name,
          },
          section: {
            id: data.section_id,
            type_id: data.section_type,
          },
          search: {
            page_number: data.page,
            type_id: data.type,
            what: data.what,
          },
          user: {
            cookie_id: data.user_cookie_id,
            origin_id: data.origin_id,
            campaigns_list: data.userCampaignIds,
          },
          tracking: {
            page_view_id: data.page_view_id,
            code: data.tracking_code,
          },
          ...(ab_test ? { ab_test } : null), // eslint-disable-line camelcase
          options: {
            is_force_no_adpage: data.is_force_no_adpage || false,
          },
        },
      },
    });

    return Api.post(url, body);
  }
}

export default Api;



// WEBPACK FOOTER //
// ./app/sdk/clickout/Api.js